import { utils as ejsUtils } from '@tangibleplay/ecommerce-js';
import { ZipCodeType } from './AddressForm.types';

export const fieldNames = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  ADDRESS_1: 'address1',
  ADDRESS_2: 'address2',
  ADDRESS_3: 'address3',
  CITY: 'city',
  STATE: 'state',
  ZIPCODE: 'zip',
  COUNTRY: 'country',
} as const;

type FieldsConfig = {
  [key: string]: {
    defaultLabel: string;
    defaultPlaceholder: string;
    name: string;
    autoComplete: string;
    format: string | ((value: string) => string);
    parse?: (value: string) => string;
    type?: string;
    maxLength?: number;
  };
};

export const getFieldsConfig = (country: string): FieldsConfig => ({
  [fieldNames.FIRST_NAME]: {
    defaultLabel: 'First Name',
    defaultPlaceholder: 'First Name',
    name: fieldNames.FIRST_NAME,
    autoComplete: 'given-name',
    format: '',
  },
  [fieldNames.LAST_NAME]: {
    defaultLabel: 'Last Name',
    defaultPlaceholder: 'Last Name',
    name: fieldNames.LAST_NAME,
    autoComplete: 'family-name',
    format: '',
  },
  [fieldNames.ADDRESS_1]: {
    defaultLabel: 'Street Address',
    defaultPlaceholder: 'Street Address',
    name: fieldNames.ADDRESS_1,
    autoComplete: 'address-level1',
    format: '',
  },
  [fieldNames.ADDRESS_2]: {
    defaultLabel: 'Address line 2',
    defaultPlaceholder: 'Address line 2',
    name: fieldNames.ADDRESS_2,
    autoComplete: 'address-level2',
    format: '',
  },
  [fieldNames.ADDRESS_3]: {
    defaultLabel: 'Special delivery instructions',
    defaultPlaceholder: 'Special delivery instructions',
    name: fieldNames.ADDRESS_3,
    autoComplete: 'address-level3',
    format: '',
  },
  [fieldNames.CITY]: {
    defaultLabel: 'City',
    defaultPlaceholder: 'City',
    name: fieldNames.CITY,
    autoComplete: 'address-level2',
    format: '',
  },
  [fieldNames.STATE]: {
    defaultLabel: 'State',
    defaultPlaceholder: 'State',
    name: fieldNames.STATE,
    autoComplete: 'address-level1',
    format: '',
  },
  [fieldNames.ZIPCODE]: {
    defaultLabel: 'Zip Code',
    defaultPlaceholder: 'Zip Code',
    name: fieldNames.ZIPCODE,
    autoComplete: 'postal-code',
    format: (zip: ZipCodeType) => ejsUtils.zipcode.formatZipCode(country, zip),
    parse: (zip: ZipCodeType) => ejsUtils.zipcode.formatZipCode(country, zip),
    type: ejsUtils.zipcode.areZipCodesAlphanumeric(country) ? 'text' : 'tel',
    maxLength: 12,
  },
  [fieldNames.COUNTRY]: {
    defaultLabel: 'Country',
    defaultPlaceholder: 'Country',
    name: fieldNames.COUNTRY,
    autoComplete: 'country',
    format: '',
  },
});
